export abstract class ApiEnvironment {
  private baseUrlBacking: string | null = null;

  set baseUrl(value: string) {
    this.baseUrlBacking = value;
  }

  get baseUrl() {
    if (!this.baseUrlBacking) {
      throw new ReferenceError('Cannot access `baseUrl` before initialization');
    }

    return this.baseUrlBacking;
  }
}
